module.exports = __webpack_public_path__ + "img/teaching-tools.2411e6c8.svg";